import { render, staticRenderFns } from "./PageContent.vue?vue&type=template&id=b798992a&lang=pug&"
import script from "./PageContent.vue?vue&type=script&lang=ts&"
export * from "./PageContent.vue?vue&type=script&lang=ts&"
import style0 from "./PageContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b798992a')) {
      api.createRecord('b798992a', component.options)
    } else {
      api.reload('b798992a', component.options)
    }
    module.hot.accept("./PageContent.vue?vue&type=template&id=b798992a&lang=pug&", function () {
      api.rerender('b798992a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/PageContent.vue"
export default component.exports